module.exports = __webpack_public_path__ + "img/img4122_title1.721a249a.jpg";